export const buildInfo = {"number": "320", "revision": "a5781d6415b4bc66aaea024ca1ad5c0412d388d3", "id": "320_2019-05-21_02-08-38"}
